export default {
  FETCH_TRUSTED_DEVICES_REQUEST: 'FETCH_TRUSTED_DEVICES_REQUEST',
  FETCH_TRUSTED_DEVICES_SUCCESS: 'FETCH_TRUSTED_DEVICES_SUCCESS',
  FETCH_TRUSTED_DEVICES_FAILURE: 'FETCH_TRUSTED_DEVICES_FAILURE',

  DELETE_TRUSTED_DEVICE_REQUEST: 'DELETE_TRUSTED_DEVICE_REQUEST',
  DELETE_TRUSTED_DEVICE_SUCCESS: 'DELETE_TRUSTED_DEVICE_SUCCESS',
  DELETE_TRUSTED_DEVICE_FAILURE: 'DELETE_TRUSTED_DEVICE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/user/actions/trusted-devices.action-types.js